import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-60700d62"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "QuickScaleRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "如图所示．量表是由四种图形组成，左侧例题区有2对组合图形", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "答题区每相邻两个图形下方都有一个小竖格，用于作答选择。从答题区中选出所有与左侧两个图形中任意一对相同的图形，并点击下面的的竖格。", -1));
const _hoisted_6 = {
  class: "mr32 pdr16",
  style: {
    "border-right": "#999999 solid 2px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "    ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_QuickScaleItem = _resolveComponent("QuickScaleItem");
  const _component_QuickScaleAnswerItem = _resolveComponent("QuickScaleAnswerItem");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center mt60 mb60"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_QuickScaleItem, {
      type: $props.data.example[0]
    }, null, 8, ["type"]), _hoisted_7, _createVNode(_component_QuickScaleItem, {
      type: $props.data.example[1]
    }, null, 8, ["type"]), _hoisted_8, _createVNode(_component_QuickScaleItem, {
      type: $props.data.example[2]
    }, null, 8, ["type"]), _hoisted_9, _createVNode(_component_QuickScaleItem, {
      type: $props.data.example[3]
    }, null, 8, ["type"])]), _createVNode(_component_el_row, {
      class: "flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "bothCenter mt32"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.options, (op, opi) => {
          return _openBlock(), _createElementBlock("div", {
            class: "mr8",
            key: `op1_${opi}`
          }, [_createVNode(_component_QuickScaleItem, {
            type: op
          }, null, 8, ["type"])]);
        }), 128))]),
        _: 1
      }), (_openBlock(), _createBlock(_component_el_row, {
        class: "bothCenter",
        key: `ans_l1_${$props.data.questionIndex}`,
        style: {
          "margin-left": "9px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, a => {
          return _createElementVNode("div", {
            key: `ans${a}`,
            class: "mr8"
          }, [_createVNode(_component_QuickScaleAnswerItem, {
            review: $data.reviewAns ? $data.reviewAns[a - 1] == '1' : null,
            checked: $props.reviewMode ? $props.data.rightAnswers[a - 1] == 1 : null,
            onAnswer: v => $options.onChoosed(a, v)
          }, null, 8, ["review", "checked", "onAnswer"])]);
        }), 64))]),
        _: 1
      }))]),
      _: 1
    })]),
    _: 1
  })]);
}